import TrustAndSafety from "../../../../src/components/trust-and-safety";
import * as React from 'react';
export default {
  TrustAndSafety,
  React
};